module.exports = __webpack_public_path__ + "img/0.129fd2db.png";